module.exports = __webpack_public_path__ + "static/WhenThePastWasAround1-aa9adc67f7c5896c3eb5d81d4167ddba.webp";